import { getUsersByUserId, User } from '@nemuru-eng/js-api-client';

import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import {
  ChangeUserByIdSchema,
  ChangeUserByIdType,
} from '@/components/shared/components/UserList/components/UserTable/components/UserTableBody/components/UserActionsRowDialog/components/ChangePassword/schemas/ChangePasswordFormSchema';
import { useChangeUserById } from '@/components/shared/components/UserList/components/UserTable/components/UserTableBody/components/UserActionsRowDialog/components/ChangeUserById/hooks/useChangeUserById';
import { EditDialogWrapper } from '@/components/shared/components/EditDialogWrapper';
import { useCache } from '@/hooks/requests/useCache';

interface ChangeUserByIdProps {
  userId: string;
  selectedUser: User;
  opened: boolean;
  setOpened: (open: boolean) => void;
  handleClose: () => void;
}

export const ChangeUserById = ({ userId, selectedUser, opened, setOpened, handleClose }: ChangeUserByIdProps) => {
  const { revalidate } = useCache(getUsersByUserId, { userId });
  const { changeUserById, loading } = useChangeUserById();

  const onSubmit = async (values: ChangeUserByIdType): Promise<void> => {
    const newUserId = values.newUserId.trim();
    await changeUserById(newUserId, selectedUser);
    handleClose();
    revalidate();
  };

  return (
    <EditDialogWrapper
      opened={opened}
      setOpened={setOpened}
      handleClose={handleClose}
      DialogProps={{
        maxWidth: 'sm',
        fullWidth: true,
      }}
      title={'CHANGE_USER'}
      onSubmitForm={onSubmit}
      saveButtonTextId={'CHANGE_USER'}
      isLoading={loading}
      formSchema={ChangeUserByIdSchema}
    >
      <TextFormField label={'NEW_USER_ID'} name={'newUserId'} />
    </EditDialogWrapper>
  );
};
